<template>
  <div>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='col-lg-12' style='padding:0px'>
        <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='errorShow'>
          <ul v-if='validationErrors'>
            <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
          </ul>
        </div>
        <div class='alert alert-success alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='successShow'>
          {{success}}
        </div>
        <div class='col-lg-6 col-sm-6' style='padding: 10px 0px 0px 10px;'>
          <span>العرض:</span>
          <select class="form-control" style="padding: 0px" v-model="record.contract_offer_id">
            <option  v-for="offer in contract_offers" v-bind:key="offer.id"  v-bind:value="offer.id">
              {{offer.date}} => {{offer.offer_name}}
            </option>
          </select>
        </div>
        <div class='col-lg-2 col-sm-2' style='padding: 10px 0px 0px 10px;'>
          <span>كود الايصال:</span>
          <input  @keypress="isNumber($event)" v-model='record.receipt_id' class='form-control' name='amount' type='text'>
        </div>
        <div class='col-lg-2 col-sm-2' style='padding: 10px 0px 0px 10px;'>
          <span>الخزنة:</span>
          <select class="form-control" style="padding: 0px" v-model="record.treasury_id">
            <option v-for="treasury in treasuries" v-bind:key="treasury.id" v-bind:value="treasury.id">
              {{ treasury.name }}
            </option>
          </select>
        </div>
        <div class='col-lg-2 col-sm-2' style='padding: 10px 0px 0px 0px;'>
          <span>المبلغ:</span>
          <input  @keypress="isNumber($event)" v-model='record.amount' class='form-control' name='amount' type='text'>
        </div>
        <div class='col-lg-2 col-sm-2' style='padding: 10px 0px 0px 10px;'>
          <span>التاريخ:</span>
          <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.date'></Datepicker>
        </div>
        <div class='col-lg-4 col-sm-4' style='padding: 10px 0px 10px 10px;'>
          <span>المحصل:</span>
          <select class="form-control" style="padding: 0px" v-model="record.conductor_id">
            <option v-for="collector in collectors" v-bind:key="collector.id" v-bind:value="collector.id">
              {{ collector.name }}
            </option>
          </select>
        </div>
        <div class='col-lg-6 col-sm-6' style='padding: 10px 0px 10px 0px;'>
          <span>ملاحظات:</span>
          <input v-model='record.notes' class='form-control' name='notes' type='text'>
        </div>
        <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 10px;  text-align:center;'>
          <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
          <button v-show="$per.value.saveReceipt" @click='showForm(0)'  type='button' class='btn btn-primary btn-outline btn-sm'>جديد</button>
          <button v-show="($per.value.saveReceipt && record.id === 0 ) || ($per.value.editReceipt && record.id > 0 )" @click='saveData'  type='button' class='btn btn-outline btn-sm btn-success'>حفظ</button>
          <button v-show="$per.value.deleteReceipt && record.id > 0 " @click='deleteData(selectedrec)' type='button' class='btn btn-outline btn-danger btn-sm'>حذف</button>
        </div>
        <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 10px 0px;'>
        <table width='100%' class='table  table-bordered '>
          <thead>
            <tr>
              <th style='text-align: center'>الايصال</th>
              <th style='text-align: center'>المبلغ</th>
              <th style='text-align: center'>التاريخ</th>
              <th style='text-align: center'>العرض</th>
              <th style='text-align: center'>المحصل</th>
              <th style='text-align: center'>الخزنة</th>
              <th style='text-align: center'>ملاحظات</th>
            </tr>
          </thead>
          <tbody v-if="!$per.value.editReceipt">
            <tr v-for='record in records' :key='record.id'>
              <td style="padding:2px" align='center'>{{record.receipt_id}}</td>
              <td style="padding:2px" align='center'>{{record.amount}}</td>
              <td style="padding:2px" align='center'>{{record.date}}</td>
              <td style="padding:2px" align='center'>{{record.offer_name}}</td>
              <td style="padding:2px" align='center'>{{record.conductor_name}}</td>
              <td style="padding:2px" align='center'>{{record.treasury_name}}</td>
              <td style="padding:2px" align='center'>{{record.notes}}</td>
            </tr>
          </tbody>
          <tbody  v-if="$per.value.editReceipt">
            <tr :class="{highlight :selectedrec == record.id}"  v-for='record in records' :key='record.id' v-on:click="showForm(record)">
              <td style="padding:2px" align='center'>{{record.receipt_id}}</td>
              <td style="padding:2px" align='center'>{{record.amount}}</td>
              <td style="padding:2px" align='center'>{{record.date}}</td>
              <td style="padding:2px" align='center'>{{record.offer_name}}</td>
              <td style="padding:2px" align='center'>{{record.conductor_name}}</td>
              <td style="padding:2px" align='center'>{{record.treasury_name}}</td>
              <td style="padding:2px" align='center'>{{record.notes}}</td>
            </tr>
          </tbody>
        </table>
      </div>
        <!-- /.table-responsive -->
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>
<style>
.highlight {
   background-color: #5A9EF5;
}
tr:hover{
   cursor: pointer;
}
</style>
<script>
import axios from 'axios'
import Datepicker from 'vuejs-datepicker'
import {ar} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
export default {
  components: {
    Datepicker
  },
  name: 'receipt',
  data () {
    return {
      ar: ar,
      contract_offers: {},
      validationErrors: '',
      records: {},
      record: {},
      treasuries: {},
      collectors: {},
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      selectedrec: null,
      branches: {}
    }
  },
  methods: {
    UpdateData (id) {
      this.branches = JSON.parse(localStorage.getItem('Branches'))
      let i = this.branches.findIndex(x => x.id === parseInt(id))
      if (i > -1) {
        this.treasuries = this.branches[i].treasuries
        this.collectors = this.branches[i].collectors
        this.stores = this.branches[i].stores
      }
    },
    GetData () {
      this.errorShow = false
      this.successShow = false
      this.isLoadingSave = false
      // -----------------------------------------------------
      this.records = this.$store.state.customerData.receipt
      this.UpdateData(this.$store.state.customerData.branche_id)
      this.record = {}
      this.showForm(0)
    },
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    isLocked: function (evt) {
      evt.preventDefault()
    },
    tabSelected () {
      this.records = this.$store.state.customerData.contract[0].receipt
      this.contractOffers()
    },
    contractOffers () {
      this.contract_offer_id = 0
      this.contract_offers = ''
      this.isContractOffersLoading = true
      axios.post(this.$apiURL + 'getContractOffers', {
        token: localStorage.getItem('token'),
        contract_id: this.$store.state.customerData.contract_id
      })
        .then(res => {
          this.isContractOffersLoading = false
          this.contract_offers = res.data
          this.contract_offers.unshift({id: 0, offer_name: 'بدون عرض'})
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isContractOffersLoading = false
        })
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.selectedrec = 0
        this.record = {'id': 0, 'treasury_id': '', 'amount': '', 'date': '', 'user_id': '', 'conductor_id': '', 'notes': '', 'contract_offer_id': null, 'receipt_id': 0}
      } else {
        this.selectedrec = recID.id
        this.record = recID
      }
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveReceipt', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        uid: this.record.uid,
        contract_id: this.$store.state.customerData.contract_id,
        treasury_id: this.record.treasury_id,
        amount: this.record.amount,
        date: this.record.date,
        user_id: this.record.user_id,
        conductor_id: this.record.conductor_id,
        notes: this.record.notes,
        receipt_id: this.record.receipt_id,
        contract_offer_id: this.record.contract_offer_id,
        customer_id: this.$store.state.customerData.id
      })
        .then(res => {
          this.isLoadingSave = false
          this.$root.$emit('Update_Totals', this.$store.state.customerData.id, res.data.totals[0].ind, res.data.totals[0].mai, res.data.totals[0].total, this.$store.state.customerData.contract_id, res.data.totals[0].balance)
          if (this.record.id === 0) {
            this.records.push(res.data.data)
            this.record = res.data.data
            this.selectedrec = res.data.data.id
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.successShow = false
      this.errorShow = false
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deleteReceipt', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        customer_id: this.$store.state.customerData.id
      })
        .then(res => {
          this.$root.$emit('Update_Totals', this.$store.state.customerData.id, res.data.totals[0].ind, res.data.totals[0].mai, res.data.totals[0].total, this.$store.state.customerData.contract_id, res.data.totals[0].balance)
          let i = this.records.map(record => record.id).indexOf(this.record.id)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
          this.showForm(0)
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.errors === 'id not found') {
            this.validationErrors = {0: 'عفوا يرجى اختيار سجل أولا'}
            this.errorShow = true
            this.isLoadingSave = false
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Contracts/Receipts.vue